import React from "react";
import { Bell, Search, Menu } from "lucide-react";
import { useAdminAuth } from "../context/AdminAuthContext";

// Props define kiya
interface NavbarProps {
  onMenuClick: () => void;
}

const AdminNavbar: React.FC<NavbarProps> = ({ onMenuClick }) => {
  const { role, name } = useAdminAuth();

  const displayName = role === "SUPER_ADMIN" ? "Super Administrator" : name;

  return (
    // 'left-0' mobile par, 'md:left-64' desktop par
    <div className="h-16 bg-[#0c0c0c]/90 backdrop-blur-md border-b border-zinc-800 flex items-center justify-between px-4 md:px-8 fixed top-0 right-0 left-0 md:left-64 z-30 transition-all duration-300">
      
      {/* Left Side: Menu Button (Mobile) & Search */}
      <div className="flex items-center gap-4 w-full md:w-auto">
        
        {/* HAMBURGER MENU (Hidden on Desktop) */}
        <button 
          onClick={onMenuClick}
          className="md:hidden text-zinc-400 hover:text-amber-500 transition-colors"
        >
          <Menu size={24} />
        </button>

        {/* Search Bar (Hidden on very small screens if needed, or adjust width) */}
        <div className="hidden md:flex items-center gap-2 bg-zinc-900 px-4 py-2 rounded-full border border-zinc-800 w-full max-w-sm">
          <Search size={16} className="text-zinc-500" />
          <input 
            type="text" 
            placeholder="Search..." 
            className="bg-transparent text-sm text-white placeholder:text-zinc-600 focus:outline-none w-full"
          />
        </div>
      </div>

      {/* Right Side: Profile & Notifications */}
      <div className="flex items-center gap-4 md:gap-6">
        
        {/* Notification Icon */}
        <button className="relative text-zinc-400 hover:text-white transition-colors">
          <Bell size={20} />
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-amber-500 rounded-full animate-pulse"></span>
        </button>

        {/* Profile Info */}
        <div className="flex items-center gap-3 pl-4 md:pl-6 border-l border-zinc-800">
          <div className="text-right hidden md:block">
            <p className="text-sm font-bold text-white leading-none">
              {displayName}
            </p>
            <p className="text-[10px] uppercase tracking-widest text-amber-500 mt-1 font-bold">
              {role?.replace("_", " ")}
            </p>
          </div>
          
          <div className="w-9 h-9 md:w-10 md:h-10 bg-gradient-to-br from-amber-500 to-amber-700 rounded-full flex items-center justify-center text-black font-bold shadow-lg shadow-amber-900/20">
            {role === "SUPER_ADMIN" ? "SA" : name?.charAt(0)}
          </div>
        </div>

      </div>
    </div>
  );
};

export default AdminNavbar;